
import React from 'react';

class TableFilterHeader extends React.Component {
  render() {
    const colSpan = this.props.colSpan;
    const style = this.props.style;
    const className = this.props.className;
    
    return (
        <th colSpan={colSpan ? colSpan : 1} style={style ? style : {}} className={className ? className : ''}>
            {this.props.filterEnabled ? 
                        this.props.children
                         : 
                        this.props.label
            }
        </th>
    )
  }
}

TableFilterHeader.displayName = 'TableFilterHeader';
TableFilterHeader.propTypes = {};
TableFilterHeader.defaultProps = {
    filterEnabled : false
};
export default TableFilterHeader;


// WEBPACK FOOTER //
// ./components/Shared/TableFilterHeader.js